import 'eonasdan-bootstrap-datetimepicker';

export function init($type, $name) {
    const elem = $($name);

    if (!elem.length || !fn[$type]) {
        return;
    }

    const pickerSettings = {
        focusOnShow: false,
        showClose: true,
        format: 'MM/DD/YYYY',
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
        },
    };

    fn[$type](elem, $name, pickerSettings);
}

const fn = {
    link(elem, $name, pickerSettings) {
        const start = elem.find($name + '-start');
        const end = elem.find($name + '-end');
        const entire = elem.find($name + '-entire');

        if (!start.length || !end.length) {
            return;
        }

        start.datetimepicker(pickerSettings);

        pickerSettings.useCurrent = false;

        end.datetimepicker(pickerSettings);

        start.on("dp.show", function () {
           end.data('DateTimePicker').hide();
        });

        start.on("dp.change", function (e) {
            end.data("DateTimePicker").minDate(e.date);

            start.find('.form__group-errors').removeClass('filled').html('').parents('.form-input-group').removeClass('has-error');

            if (entire.length) {
                entire.prop('checked', false);
            }
        });

        end.on("dp.show", function () {
            start.data('DateTimePicker').hide();
        });

        end.on("dp.change", function (e) {
            start.data("DateTimePicker").maxDate(e.date);

            end.find('.form__group-errors').removeClass('filled').html('').parents('.form-input-group').removeClass('has-error');

            if (entire.length) {
                entire.prop('checked', false);
            }
        });

        entire.change(function () {
            if(this.checked) {
                elem.find($name + '-start input').val('');
                elem.find($name + '-end input').val('');
            }
        });
    },
    future(input, $name, pickerSettings) {
        pickerSettings.minDate = new Date();
        input.datetimepicker(pickerSettings);

        input.on("dp.change", function (e) {
            input.find('.form__group-errors').removeClass('filled').html('').parents('.form-input-group').removeClass('has-error');
        });
    }
};
